import React from 'react';
import { makePrioStyles } from '../../../theme/utils';
import { CreateGlobalProjectSetting } from '../../../models/Configuration';
import Flex from '../../../components/Flex';
import { Typography } from 'antd';
import { Button } from '@prio365/prio365-react-library';
import { GlobalProjectSettingsTable } from './GlobalProjectSettingsTable';
import { useTranslation } from 'react-i18next';
import { GlobalProjectSettingId, GlobalProjectSettingType } from '../../../models/Types';
import PrioSpinner from '../../../components/PrioSpinner';
import classNames from 'classnames';
import { useGlobalProjectSettings } from '../hooks/useGlobalProjectSettings';

const TABLE_TYPE_MAP: Record<string, string> = {
  emailSignature: 'signature',
  emailSubject: 'subject',
  projectDocumentPrefix: 'projectDocumentPrefix',
};

const useStyles = makePrioStyles((theme) => ({
  root: {
    backgroundColor: theme.old.palette.backgroundPalette.content,
    height: '100%',
    overflowY: 'auto',
  },
  spin: {
    backgroundColor: theme.old.palette.backgroundPalette.sub,
    height: '100%',
    width: '100%',
  },
  actionRow: {
    padding: theme.old.spacing.defaultPadding,
    paddingTop: 0,
  },
  title: {
    padding: theme.old.spacing.defaultPadding,
    marginBottom: '0!important',
  },
}));

interface GlobalStringSettingPageProps {
  className?: string;
  settingType: GlobalProjectSettingType;
  title: string;
}

export const GlobalStringSettingPage: React.FC<GlobalStringSettingPageProps> = (
  props
) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { className, settingType, title } = props;

  const {
    settings,
    settingsSaving,
    areSettingsDirty,
    setDefaultSetting,
    createSetting,
    setIsDirtyChangedSettings,
    saveSettings,
    deleteSetting,
  } = useGlobalProjectSettings(settingType);

  const tableType = TABLE_TYPE_MAP[settingType] ?? settingType;

  if (settings === null) {
    return (
      <div className={classes.spin}>
        <div className="prio-flex-center-center prio-flex-column prio-container-fullscreen-height">
          <PrioSpinner size="large" />
        </div>
      </div>
    );
  }

  return (
    <div className={classNames(classes.root, className)}>
      <Flex.Column>
        <Typography.Title className={classes.title}>{title}</Typography.Title>
        <GlobalProjectSettingsTable
          settings={settings}
          onIsDirtyChanged={setIsDirtyChangedSettings}
          onNewSetting={(newSetting: CreateGlobalProjectSetting) =>
            createSetting(newSetting)
          }
          onDeleteSetting={(settingId: GlobalProjectSettingId) =>
            deleteSetting(settingId)
          }
          onSetDefaultSetting={(settingId: GlobalProjectSettingId) =>
            setDefaultSetting(settingId)
          }
          type={tableType}
        />
        <Flex.Row className={classes.actionRow} justifyContent="flex-end">
          <Button
            disabled={!areSettingsDirty || settingsSaving}
            onClick={saveSettings}
          >
            {t('common:actions.save')}
          </Button>
        </Flex.Row>
      </Flex.Column>
    </div>
  );
};

export default GlobalStringSettingPage;
